import { IfPermission } from '@app/core/auth/authorization/components/IfPermission';
import { fragmentsPermissions } from '@mi-front/api-clients';
import { QueryView } from '@mi-front/ui';
import { Box } from '@mui/material';
import { useIntl } from 'react-intl';
import {
  SocialExportPublishSectionHeader,
  socialExportPublishMessages,
} from '@app/modules/social-export/publish';
import { useComposition } from '../../hooks/useComposition';
import { ComposeSocialExportPanorama } from './ComposeSocialExportPanorama';
import { ComposeSocialExportPublishDropdown } from './ComposeSocialExportPublishDropdown';
import { useCompositionSocialUploadsQuery } from './useCompositionSocialUploadsQuery';

/**
 * Composition social export block: permission-gated; title, publish dropdown, and uploads list.
 */
export function ComposeSocialPublishView() {
  const { composition } = useComposition();
  const uploadsQuery = useCompositionSocialUploadsQuery(composition.id);
  const { $t } = useIntl();

  return (
    <IfPermission permission={fragmentsPermissions.Fragments_SocialPublish}>
      <QueryView query={uploadsQuery} inline>
        {() => (
          <Box>
            <SocialExportPublishSectionHeader
              title={$t(socialExportPublishMessages.sectionTitle)}
              actions={<ComposeSocialExportPublishDropdown uploadsByPlatform={uploadsQuery.data} />}
            />
            <ComposeSocialExportPanorama uploadsByPlatform={uploadsQuery.data} />
          </Box>
        )}
      </QueryView>
    </IfPermission>
  );
}
